import { render, staticRenderFns } from "./FrankfurtLevel.vue?vue&type=template&id=79c8ce04&scoped=true&"
import script from "./FrankfurtLevel.vue?vue&type=script&lang=js&"
export * from "./FrankfurtLevel.vue?vue&type=script&lang=js&"
import style0 from "./FrankfurtLevel.vue?vue&type=style&index=0&id=79c8ce04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8ce04",
  null
  
)

export default component.exports